import { ESymbolStatus, ESymbolType } from '@webtrader/core/api/market/symbols';
import request from '@webtrader/core/request';

export enum ESignalAction {
  BUY = 0,
  SELL = 1
}

export enum ESignalDirection {
  BULLISH = 0,
  BEARISH = 1,
  NEUTRAL = 2
}

export enum ESignalOrderStatus {
  DRAFT = 0,
  EXPIRED = 12,
  BUYSTOP = 15,
  BUYLIMIT = 16,
  LIVETRADE = 9,
  SELLSTOP = 13,
  SELLLIMIT = 14,
  CLOSEDFLAT = 7,
  CLOSEDLOSS = 6,
  CLOSEDPROFIT = 5
}

export interface ISignal {
  id: string;
  type: ESymbolType;
  watch: boolean;
  action: ESignalAction;
  symbol: string;
  status: ESignalOrderStatus;
  duration: string;
  uniqueId: string;
  direction: ESignalDirection;
  confidence: number;
  description: string;
  symbolStatus: ESymbolStatus;
  modifiedDate: number;
  publishedDate: number;
  isDisplay: boolean;
}

export interface ISignalCategoriesResult {
  symbolTypes: ESymbolType[];
}

export interface IHideSignalCategoriesParams {
  symbolTypeList: ESymbolType[];
}

export default {
  all: () => request.get<ISignal[]>('/api/plugin/v1/signals'),
  hide: (params: IHideSignalCategoriesParams) => request.post('/api/plugin/v1/signals/hide', params),
  categories: () => request.get<ISignalCategoriesResult>('/api/plugin/v1/signals/categories'),
  favourites: () => request.get<ISignal[]>('/api/plugin/v1/signals/favourite')
};
